import { compose } from 'ramda';
import { withHandlers } from 'recompose';
import { launchGame } from '@core/js/components/common/Game/actions';

export default compose(
    withHandlers({
        launchGame: ({ customLaunchGame, code, mode = 1, randomGame, gameLaunchType, queryString, categoryName }) => (data) => {
            /* TotalCasino changes - categoryName support */
            const gameCode = typeof code === 'function' ? code() : code;
            let args = { code: gameCode, mode, randomGame, gameLaunchType, queryString, categoryName };

            if (!(data instanceof Event)) {
                args = { ...args, ...data };
            }

            if (customLaunchGame) {
                customLaunchGame(args);
            } else {
                launchGame(args);
            }
        }
    })
);
